const config = {
  apiUrl: process.env.REACT_APP_YAAK_API_URL || '{{ REACT_APP_YAAK_API_URL }}',
  auth: {
    audience:
      process.env.REACT_APP_AUTH_AUDIENCE || '{{ REACT_APP_AUTH_AUDIENCE }}',
    clientId:
      process.env.REACT_APP_AUTH_CLIENT_ID || '{{ REACT_APP_AUTH_CLIENT_ID }}',
    domain: process.env.REACT_APP_AUTH_DOMAIN || '{{ REACT_APP_AUTH_DOMAIN }}',
    scope:
      process.env.REACT_APP_AUTH_SCOPE || 'openid profile email offline_access',
  },
  environment: process.env.REACT_APP_NODE_ENV || '{{ REACT_APP_NODE_ENV }}',
  showSwagger: process.env.SHOW_SWAGGER || false,
  urls: () => {
    return {
      privacy: 'https://www.synpli.de/dsgvo-datenschutzvereinbarung',
      support: `https://www.help.synpli.de`,
      terms: 'https://www.synpli.de/produkt-datenschutzrichtlinie',
    }
  },
  locales: {
    default: 'en',
    supported: ['en', 'de'],
    url: '/lang',
  },
  roles: ['synpli-admin', 'ds-admin', 'ds-instructor', 'ds-student'],
  sentry: {
    dns: process.env.SENTRY_DNS || '{{ SENTRY_DNS }}',
  },
  mapbox: {
    accessToken: process.env.MAPBOX_ACCESS_TOKEN || '{{ MAPBOX_ACCESS_TOKEN }}',
  },
}

export default config
